module.exports = __webpack_public_path__ + "assets/img/bg-05.d6fec4cb.png";